import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    jQuery(".best_in_place").best_in_place();
  }
}
